import { render, staticRenderFns } from "./TitleTips.vue?vue&type=template&id=4b00adaf&scoped=true"
import script from "./TitleTips.vue?vue&type=script&lang=js"
export * from "./TitleTips.vue?vue&type=script&lang=js"
import style0 from "./TitleTips.vue?vue&type=style&index=0&id=4b00adaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b00adaf",
  null
  
)

export default component.exports